export default {
	menu: {
		notification: 'notification',
		settings: 'settings',
		language: 'language',
		logout: 'logout'
	}
}